import React, { Component } from "react";
import { NavBar, SideBar, Footer } from "../../components";
import "react-toastify/dist/ReactToastify.css";
import PouchDB from "pouchdb";
import PouchdbFind from "pouchdb-find";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { cepMask } from "../../mask";
import axios from "axios";
import clienteModel from "../../models/cliente";
import agendaModel from "../../models/agenda";
import usuarioModel from "../../models/usuario";
import queryString from "query-string";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import debounce from "debounce-promise";
PouchDB.plugin(PouchdbFind);

export default class AgendaNova extends Component {
  constructor(props) {
    super(props);
    this.transformDataComboBoxCliente =
      this.transformDataComboBoxCliente.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.notificar = this.notificar.bind(this);
    this.buscaDadosCliente = this.buscaDadosCliente.bind(this);
    this.promiseOptions = this.promiseOptions.bind(this);
    this.getDefaultAgenda = this.getDefaultAgenda.bind(this);
    this.transformDataComboBox = this.transformDataComboBox.bind(this);
    this.onChangeSwitch = this.onChangeSwitch.bind(this);
    this.cadastrarAgenda = this.cadastrarAgenda.bind(this);
    this.validarAgenda = this.validarAgenda.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.loadUsuario = this.loadUsuario.bind(this);
    this.abrirPaginaEditarContatos = this.abrirPaginaEditarContatos.bind(this);
    this.toggle = this.toggle.bind(this);

    this.debouncedLoadOptions = debounce(
      (inputValue) => this.promiseOptions(inputValue),
      500,
      {
        leading: true,
      }
    );

    this.state = {
      //actionPage: this.props.action,
      actionPage: "CADASTRAR",
      agenda: this.getDefaultAgenda(),
      contatos: [],
      errors: {
        cliente: false,
      },
      agendaHorario: false,
      usuario: null,
      modal: false,
      idCliente: null,
    };
  }

  async componentDidMount() {
    let db = await new PouchDB(this.props.getBaseUrlBanco(), {
      auth: this.props.getUserBanco(),
      skipSetup: true,
    });
    this.setState(
      {
        db: db,
      },
      async () => {
        await this.loadUsuario();
        if (this.state.actionPage === "EDITAR") {
          let idAgenda = queryString.parse(this.props.location.search).id;

          if (idAgenda === undefined) {
            this.props.history.push("/home");
            return false;
          }

          let agendaBanco = await agendaModel.findById(this.state.db, idAgenda);

          let cliente = await clienteModel.findById(
            this.state.db,
            agendaBanco.cliente._id
          );

          cliente.value = cliente.descFormat;
          cliente.label = cliente.descFormat;

          let contatos = cliente.contatos;
          contatos = this.transformDataComboBox(contatos);

          agendaBanco.contato = contatos.find(
            (i) => i.idIntegracao === agendaBanco.contato.idIntegracao
          );

          agendaBanco.cliente = cliente;
          agendaBanco.data = new Date(agendaBanco.data);
          agendaBanco.acao = {
            value: agendaBanco.acao,
            label: agendaBanco.acao === "visitar" ? "Visita" : "Ligação",
          };

          this.setState({
            agenda: agendaBanco,
            contatos,
            agendaHorario: agendaBanco.horario !== null ? true : false,
          });
        }
      }
    );
  }

  getDefaultAgenda() {
    return {
      type: "agenda",
      tipo: "manual", //"programado"
      acao: {
        value: "visitar",
        label: "Visita",
      }, //"ligar"
      cliente: null,
      contato: null,
      obs: "",
      data: new Date(),
      horario: null,
      status: "P",
      idAgendaPai: null,
    };
  }

  transformDataComboBoxCliente(lista) {
    lista = lista.map((item) => {
      item.value = item.descFormat;
      item.label = item.descFormat;
      return item;
    });
    return lista;
  }

  transformDataComboBox(lista) {
    lista = lista.map((item) => {
      item.value = item.desc;
      item.label = item.desc;
      return item;
    });
    return lista;
  }

  async handleChangeSelect(item, tipo) {
    let agendaLocal = this.state.agenda;

    if (tipo === "cliente") {
      item = await this.buscaDadosCliente(item._id);
      item.value = item.descFormat;
      item.label = item.descFormat;
      let contatos = item.contatos;
      contatos = this.transformDataComboBox(contatos);

      let clienteValido = true;

      for (let contato of contatos) {
        if (contato.status === "A") {
          if (contato.email === "" || contato.fone === "") {
            clienteValido = false;
            this.setState({ modal: true, idCliente: item._id });
          }
        }
      }

      if (!clienteValido) {
        this.setState({
          contatos: [],
          agenda: this.getDefaultAgenda(),
        });
        return false;
      } else {
        agendaLocal.cliente = item;
        agendaLocal.contato = item.contatos[0];

        this.setState({
          contatos,
          agenda: agendaLocal,
        });
      }
    } else {
      this.setState({ agenda: { ...this.state.agenda, [tipo]: item } });
    }
  }

  handleChangeInput(e, tipo) {
    this.setState({ agenda: { ...this.state.agenda, [tipo]: e.target.value } });
  }

  notificar(type, message) {
    toast[type](message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  }

  async buscaDadosCliente(id) {
    let cliente = await clienteModel.findById(this.state.db, id);
    return cliente;
  }

  promiseOptions(inputValue) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        if (inputValue === "") {
          let clientes = await clienteModel.findAll(this.state.db);

          clientes = this.transformDataComboBoxCliente(clientes);
          this.setState({ clientes });

          resolve(clientes);
        } else {
          let aux = inputValue.substr(0, 1);
          let len = 2;
          if (aux == "&" || aux == "%") len = 3;
          if (inputValue.length >= len) {
            let clientes = await clienteModel.findAllByDesc(
              this.state.db,
              inputValue
            );

            clientes = this.transformDataComboBoxCliente(clientes);
            this.setState({ clientes });
            resolve(clientes);
          } else {
            resolve([]);
          }
        }
      }, 100);
    });
  }

  async onChangeSwitch(chk) {
    let localAgenda = this.state.agenda;
    this.setState({ agendaHorario: chk, agenda: localAgenda });
  }

  validarAgenda() {
    let errorsLocal = this.state.errors;
    let agenda = this.state.agenda;
    let valido = true;

    if (agenda.cliente === null) {
      errorsLocal.cliente = true;
      valido = false;
    } else {
      errorsLocal.cliente = false;
    }

    if (agenda.contato === null) {
      errorsLocal.contato = true;
      valido = false;
    } else {
      errorsLocal.contato = false;
    }

    this.setState({ errors: errorsLocal });
    return valido;
  }

  async cadastrarAgenda() {
    if (!this.validarAgenda()) {
      this.notificar("warning", "Preencha os dados corretamente!");
      return false;
    }

    let agenda = Object.assign({}, this.state.agenda);
    let vendedor = this.state.usuario.vendedores.find(
      (vend) => vend.idIntegracao === agenda.cliente.vendedor.idIntegracao
    );

    let cliente = {
      _id: agenda.cliente._id,
      idIntegracao: agenda.cliente.idIntegracao,
      desc: agenda.cliente.desc,
      descFormat: agenda.cliente.descFormat,
      fantasia: agenda.cliente.fantasia,
    };

    let contato = {
      _id: agenda.contato._id,
      idIntegracao: agenda.contato.idIntegracao,
      desc: agenda.contato.desc,
      email: agenda.contato.email,
      fone: agenda.contato.fone,
      cel: agenda.contato.cel,
    };

    agenda.cliente = cliente;
    agenda.contato = contato;
    agenda.vendedor = {
      desc: vendedor.desc,
      idIntegracao: vendedor.idIntegracao,
    };

    agenda.acao = agenda.acao.value;

    if (this.state.agendaHorario) {
      agenda.horario = moment(agenda.data).format("HH:mm");
    } else {
      agenda.horario = null;
    }

    if (this.state.actionPage === "CADASTRAR") {
      agenda.dataCriacao = new Date();
      await this.state.db.post(agenda);
      this.notificar("success", "Agenda criada com sucesso!");

      this.setState(
        { agenda: this.getDefaultAgenda(), contatos: [], agendaHorario: false },
        () => {}
      );
    } else {
      await this.state.db.put(agenda);
      this.notificar("success", "Agenda editada com sucesso!");

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  }

  onChangeDate(data) {
    this.setState({ agenda: { ...this.state.agenda, data: data } });
  }

  async loadUsuario() {
    let usuario = await usuarioModel.find(this.state.db);
    this.setState({ usuario });
  }

  abrirPaginaEditarContatos() {
    localStorage.setItem("urlAnterior", this.props.history.location.pathname);
    this.props.history.push(`/contatos/editar?id=${this.state.idCliente}`);
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  render() {
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <div className="container-scroller font-app">
          <NavBar title="Nova Agenda Manual" />
          <div className="container-fluid page-body-wrapper">
            <SideBar itemActive={"nova-agenda"} />
            <div className="main-panel">
              <div className="content-wrapper">
                {/* <TitleAndDescription
                  title={`Cadastrar Pedido`}
                  description="Adicionar um novo pedido"
                /> */}

                <div className="row font-size-13">
                  <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                      <div className="card-body dashboard-tabs p-0">
                        <div className="tab-content py-0 px-0">
                          <div
                            className="tab-pane fade show active"
                            id="overview"
                            role="tabpanel"
                            aria-labelledby="overview-tab"
                          >
                            <div className="d-flex flex-wrap justify-content-xl-between">
                              <div
                                style={{
                                  padding: "15px",
                                  float: "left",
                                  width: "100%",
                                }}
                              >
                                <div
                                  className="row"
                                  style={{ padding: "15px" }}
                                >
                                  <div className="col-md-5 float-left pd-pedido">
                                    <div className="form-group">
                                      <label>Cliente</label>
                                      <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={(inputValue) =>
                                          this.debouncedLoadOptions(inputValue)
                                        }
                                        value={this.state.agenda.cliente}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "cliente"
                                          )
                                        }
                                        className={`${
                                          this.state.errors.cliente
                                            ? "select-error"
                                            : ""
                                        }`}
                                        placeholder="Selecione"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-5 float-left pd-pedido">
                                    <div className="form-group">
                                      <label style={{ marginRight: "3px" }}>
                                        Contato
                                      </label>{" "}
                                      <Select
                                        options={this.state.contatos}
                                        value={this.state.agenda.contato}
                                        onChange={(item) =>
                                          this.handleChangeSelect(
                                            item,
                                            "contato"
                                          )
                                        }
                                        // className={`${
                                        //   this.state.errors.contato ? "select-error" : ""
                                        // }`}
                                        placeholder="Selecione"
                                        isDisabled={
                                          this.state.agenda.cliente === null
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-2 float-left pd-pedido">
                                    <div className="form-group">
                                      <label style={{ marginRight: "3px" }}>
                                        Tipo da agenda
                                      </label>{" "}
                                      {/* {JSON.stringify(this.state.agenda)} */}
                                      <Select
                                        options={[
                                          {
                                            value: "visitar",
                                            label: "Visita",
                                          },
                                          {
                                            value: "ligar",
                                            label: "Ligação",
                                          },
                                        ]}
                                        value={this.state.agenda.acao}
                                        onChange={(item) =>
                                          this.handleChangeSelect(item, "acao")
                                        }
                                        placeholder="Selecione"
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6 float-left pd-pedido">
                                    <div className="form-group">
                                      <label style={{ marginRight: "3px" }}>
                                        Observação
                                      </label>{" "}
                                      <textarea
                                        className="form-control heigth-textarea"
                                        rows="2"
                                        value={this.state.agenda.obs}
                                        onChange={(e) =>
                                          this.handleChangeInput(e, "obs")
                                        }
                                        ref={(node) => {
                                          if (node) {
                                            node.style.setProperty("height", "inherit", "important");
                                          }
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 float-left pd-pedido">
                                    <div className="form-group">
                                      <label style={{ marginRight: "3px" }}>
                                        Agendar um horário?
                                      </label>{" "}
                                      <div className="item-switch">
                                        <Switch
                                          checked={this.state.agendaHorario}
                                          onChange={(chk) =>
                                            this.onChangeSwitch(chk)
                                          }
                                          onColor="#f0e8fc"
                                          onHandleColor="#7c3e7a"
                                          handleDiameter={25}
                                          uncheckedIcon={false}
                                          checkedIcon={false}
                                          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                          activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                          height={16}
                                          width={48}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-3 float-left pd-pedido">
                                    <div className="form-group">
                                      <label style={{ marginRight: "3px" }}>
                                        Data da agenda
                                      </label>{" "}
                                      {this.state.agendaHorario && (
                                        <DatePicker
                                          selected={this.state.agenda.data}
                                          withPortal
                                          customInput={
                                            <input className="form-control font-size-13" />
                                          }
                                          dateFormat="dd/MM/yyyy HH:mm"
                                          onChange={(date) =>
                                            this.onChangeDate(date)
                                          }
                                          showTimeSelect
                                          locale="pt-BR"
                                        />
                                      )}
                                      {!this.state.agendaHorario && (
                                        <DatePicker
                                          selected={this.state.agenda.data}
                                          withPortal
                                          customInput={
                                            <input className="form-control font-size-13" />
                                          }
                                          dateFormat="dd/MM/yyyy"
                                          onChange={(date) =>
                                            this.onChangeDate(date)
                                          }
                                          locale="pt-BR"
                                        />
                                      )}
                                    </div>
                                  </div>

                                  <div className="col-12 pd-pedido">
                                    <button
                                      className="btn btn-success"
                                      onClick={() => this.cadastrarAgenda()}
                                      // onClick={() =>
                                      //   //this.cadastrarPedido("orcamento")
                                      // }
                                      // onClick={this.salvarEndereco}
                                    >
                                      Cadastrar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
